module.exports = __webpack_public_path__ + "bundle/assets/red-man-100@1x.8c36121d.png";


//////////////////
// WEBPACK FOOTER
// ./src/kiosk/YouAreHereLayer/red-man-100@1x.png
// module id = 68
// module chunks = 0